import { supabase } from "../supabase";
import trimSentence from "../utils/trimSentence";
/* 도서관 정보나루에서 받아 둔 유형별 책. scripts/fetch-library-recs.mjs 가
   매일 새벽에 다시 만든다. 아래 PICKS 48권을 씨앗으로, 전국 도서관에서 그
   책을 빌린 사람이 함께 빌린 책을 받는다 — 검색이 아니라 대출 기록이라
   기계 생성 책이나 법령집이 올라올 수가 없다. */
import LIB from "../data/libraryRecs.json";

/**
 * 북BTI 유형에 어울리는 책.
 *
 * 검색어로 찾는 방식은 두 번 시도했다가 버렸다. 실제 응답을 보고 버린 것이다.
 *   1) 유형의 말('밤의 사색', '기록의 힘')로 찾기
 *      → 저자가 '서울 AI'·'넥스트북 라이프' 인 기계 생성 책이 상위에 왔다.
 *   2) 분야명('한국소설', '심리학 교양', '현대시')으로 찾기
 *      → 수능 교재, 월간지, 경제자유구역법 법령집이 왔다.
 *   카카오 책 API 는 그 말이 제목에 든 책을 올려줄 뿐, 그 분야의 좋은 책을
 *   골라주지 않는다. 검색으로는 이 칸을 채울 수 없다.
 *
 * 그래서 책은 사람이 고른다. 아래 목록이 그것이고, 카카오는 표지와 소개문을
 * 채우는 데만 쓴다.
 *
 * 알라딘의 '분야별 신간' 도 검토했으나 쓸 수 없다 — 신규 인증키 신청이
 * 2026-09-04 에 끝났고 기존 키도 2026-10-30 에 끊긴다(알라딘 공지).
 *
 * 목록은 늘려도 된다. 유형마다 여섯 권을 두고 그중 셋을 무작위로 보여준다.
 */

/* 유형별 추천 목록. t=제목, a=저자(카카오 조회에 둘 다 쓴다), g=장르.
   장르는 사람이 적는다 — 카카오 책 API 는 분야를 돌려주지 않아, 비워두면
   담은 책이 전부 '기타' 로 쌓여 통계의 장르 칸이 무의미해진다.
   값은 GENRE_LIST(data/constants.js) 안의 것만 쓴다. */
const PICKS = {
  night: [
    { t: "소년이 온다", a: "한강" , g: "소설" },
    { t: "아몬드", a: "손원평" , g: "소설" },
    { t: "쇼코의 미소", a: "최은영" , g: "소설" },
    { t: "파친코", a: "이민진" , g: "소설" },
    { t: "사람, 장소, 환대", a: "김현경" , g: "인문학" },
    { t: "노르웨이의 숲", a: "무라카미 하루키" , g: "세계문학" },
  ],
  sentence: [
    { t: "입 속의 검은 잎", a: "기형도" , g: "시" },
    { t: "당신의 이름을 지어다가 며칠은 먹었다", a: "박준" , g: "시" },
    { t: "마음사전", a: "김소연" , g: "에세이" },
    { t: "여행의 이유", a: "김영하" , g: "에세이" },
    { t: "슬픔이 없는 십오 초", a: "심보선" , g: "시" },
    { t: "사랑의 물리학", a: "김인육" , g: "시" },
  ],
  slow: [
    { t: "아주 작은 습관의 힘", a: "제임스 클리어" , g: "자기계발" },
    { t: "지적 대화를 위한 넓고 얕은 지식", a: "채사장" , g: "인문학" },
    { t: "배움의 발견", a: "타라 웨스트오버" , g: "자서전" },
    { t: "그릿", a: "앤절라 더크워스" , g: "자기계발" },
    { t: "공부머리 독서법", a: "최승필" , g: "교육" },
    { t: "미움받을 용기", a: "기시미 이치로" , g: "자기계발" },
  ],
  chaser: [
    { t: "사피엔스", a: "유발 하라리" , g: "인문학" },
    { t: "코스모스", a: "칼 세이건" , g: "과학" },
    { t: "이기적 유전자", a: "리처드 도킨스" , g: "과학" },
    { t: "총, 균, 쇠", a: "재레드 다이아몬드" , g: "역사" },
    { t: "넥서스", a: "유발 하라리" , g: "인문학" },
    { t: "떨림과 울림", a: "김상욱" , g: "과학" },
  ],
  keeper: [
    { t: "나의 문화유산답사기", a: "유홍준" , g: "예술" },
    { t: "역사의 쓸모", a: "최태성" , g: "역사" },
    { t: "곰브리치 세계사", a: "에른스트 곰브리치" , g: "역사" },
    { t: "다른 방식으로 보기", a: "존 버거" , g: "예술" },
    { t: "기록의 쓸모", a: "이승희" , g: "에세이" },
    { t: "로마인 이야기", a: "시오노 나나미" , g: "역사" },
  ],
  voyager: [
    { t: "듄", a: "프랭크 허버트" , g: "SF" },
    { t: "프로젝트 헤일메리", a: "앤디 위어" , g: "SF" },
    { t: "우리가 빛의 속도로 갈 수 없다면", a: "김초엽" , g: "SF" },
    { t: "삼체", a: "류츠신" , g: "SF" },
    { t: "반지의 제왕", a: "J.R.R. 톨킨" , g: "판타지" },
    { t: "해리 포터와 마법사의 돌", a: "조앤 K. 롤링" , g: "판타지" },
  ],
  feeler: [
    { t: "죽고 싶지만 떡볶이는 먹고 싶어", a: "백세희" , g: "에세이" },
    { t: "나는 나로 살기로 했다", a: "김수현" , g: "에세이" },
    { t: "슬픔을 공부하는 슬픔", a: "신형철", g: "에세이" },
    { t: "모든 요일의 기록", a: "김민철" , g: "에세이" },
    { t: "하마터면 열심히 살 뻔했다", a: "하완" , g: "에세이" },
    { t: "위로의 미술관", a: "진병관" , g: "예술" },
  ],
  diver: [
    { t: "용의자 X의 헌신", a: "히가시노 게이고" , g: "미스터리" },
    { t: "화차", a: "미야베 미유키" , g: "미스터리" },
    { t: "그리고 아무도 없었다", a: "애거사 크리스티" , g: "미스터리" },
    { t: "종의 기원", a: "정유정" , g: "스릴러" },
    { t: "재수사", a: "장강명" , g: "스릴러" },
    { t: "주홍색 연구", a: "아서 코난 도일" , g: "미스터리" },
  ],
};

/* 제목을 견주기 위한 꼴. 괄호 안 서점 표기(큰글자도서 / 개정판…)와 뒤에
   붙은 권 번호를 떼면 같은 책의 다른 판이 하나로 모인다. */
const norm = (t) => String(t ?? "")
  .replace(/[([][^)\]]*[)\]]/g, " ")
  .replace(/\s*\d+\s*$/, "")
  .replace(/\s+/g, " ")
  .trim();

/* 괄호 안은 서점 표기다 — '기프트 에디션', '200만 부 기념 스페셜 에디션',
   '미니미니북', '양장본 Hardcover'. 카드에 그대로 나오면 지저분하고, 담기를
   누르면 그 제목으로 책이 저장돼 같은 책이 둘로 쌓인다. 떼고 쓴다.
   권 번호(파친코 1, 듄 1)는 남긴다 — 실제로 그 권이다. */
const cleanTitle = (t) => String(t ?? "")
  .replace(/[([][^)\]]*[)\]]/g, " ")
  .replace(/\s+/g, " ")
  .trim();

/** 카카오 응답 한 줄 → 앱이 쓰는 책 모양 (useBookSearch 와 같게 맞춘다) */
function fold(doc) {
  return {
    title: cleanTitle(doc.title) || "제목 없음",
    author: (doc.authors || []).join(", ") || "저자 미상",
    cover: doc.thumbnail || null,
    genre: null,
    description: trimSentence(doc.contents),
    publishedDate: doc.datetime ? doc.datetime.slice(0, 10) : "",
    isbn: doc.isbn || "",
  };
}

/** 고른 책 한 권을 카카오에서 찾아 표지·소개문을 채운다. 못 찾으면 null. */
async function lookup({ t, a, g }) {
  const { data, error } = await supabase.functions.invoke("search-books", {
    body: { q: `${t} ${a}`, size: 10 },
  });
  if (error || !data?.documents?.length) return null;
  const want = norm(t);
  /* 제목이 맞는 것만 받는다. 엉뚱한 첫 결과를 그냥 쓰면 목록을 고른 뜻이
     사라진다 — 표지가 없는 판본도 버린다. */
  const hit = data.documents.find((d) => norm(d.title) === want)
    || data.documents.find((d) => norm(d.title).startsWith(want));
  if (!hit || !hit.thumbnail) return null;
  return { ...fold(hit), genre: g || null };
}

const shuffle = (arr) => arr
  .map((v) => [Math.random(), v])
  .sort((x, y) => x[0] - y[0])
  .map(([, v]) => v);

/* 정보나루의 분류('문학 > 한국문학 > 소설')를 무루의 장르로 옮긴다.
   담기를 누르면 이 값이 그대로 books.genre 에 저장되므로, 옮기지 않고
   넘기면 장르 칸이 '문학 > 한국문학 > 소설' 로 오염된다.
   모르는 분류는 null 로 둔다 — 억지로 '기타' 를 넣으면 지금도 91권이나
   되는 '기타' 가 더 늘고, 그건 취향이 아니라 빈칸이다. */
const KDC_TO_GENRE = {
  소설: "소설", 시: "시", 수필: "에세이", 희곡: "희곡", 만화: "만화",
  "르포르타주 및 기타": "에세이", "일기, 서간, 기행": "에세이",
  미술사: "예술", 예술: "예술", 음악: "음악", 건축공학: "건축",
  "회화, 도화": "예술", 영화: "예술",
  육아: "교육", "학습지도, 교육방법": "교육",
  "강연집, 수필집, 연설문집": "에세이",
  "독서 및 정보매체의 이용": "인문학",
  "전략, 전술": "사회과학", "국가와 개인 및 집단": "정치",
  철학: "철학", "윤리학, 도덕철학": "철학", "도덕훈, 교훈": "자기계발",
  심리학: "심리학", "차이심리학": "심리학", "응용심리학 일반": "심리학",
  역사: "역사", "세계사, 세계문화사": "역사", 한국: "역사",
  경영관리: "경영", 경제학: "경제", 정치학: "정치", 사회학: "사회과학",
  "사회학, 사회문제": "사회과학", 교육학: "교육", "유아 및 초등교육": "교육",
  물리학: "과학", 천문학: "과학", 생물과학: "과학", 생물진화: "과학",
  수학: "수학", 해석학: "수학", 자연과학: "과학", 의학: "의학",
  종교: "종교", 기독교: "종교", 불교: "종교", 언어: "언어",
};
/** '문학 > 한국문학 > 소설' → '소설'. 모르면 null. */
function toGenre(cls) {
  const last = String(cls ?? "").split(">").pop().trim();
  return KDC_TO_GENRE[last] ?? null;
}

/** 정보나루 한 줄 → 카드가 쓰는 모양 (fold 와 같은 열쇠를 쓴다) */
const foldLib = (b) => ({
  title: b.title,
  author: b.author || "저자 미상",
  cover: b.cover || null,
  genre: toGenre(b.cls),
  description: null,   // 정보나루 추천 목록에는 소개문이 없다
  publishedDate: "",
  isbn: b.isbn || "",
});

/**
 * @param {string} typeKey   북BTI 유형
 * @param {Array} skipTitles 이미 내 행성에 있는 책 제목 (빼고 고른다)
 * @param {number} count
 * @returns {Promise<Array>} 못 찾은 책은 빠진다. 하나도 없으면 빈 배열.
 */
export async function recommendForType(typeKey, skipTitles = [], count = 3) {
  const skip = new Set([...skipTitles].map(norm));

  /* 1순위: 도서관 대출 기록에서 온 책. 표지가 이미 들어 있어 아무것도
     조회하지 않는다 — 예전에는 세 칸을 채우려고 카카오를 다섯 번 불렀다. */
  const fromLib = shuffle((LIB?.types?.[typeKey] ?? []).filter((b) => b.cover && !skip.has(norm(b.title))))
    .slice(0, count)
    .map(foldLib);
  if (fromLib.length >= count) return fromLib;

  /* 2순위: 사람이 고른 48권. 파일이 없거나(처음 받기 전) 유형 하나가 비어도
     추천 칸이 통째로 사라지지 않게 남겨 둔다. 이미 채운 책은 또 넣지 않는다. */
  const list = PICKS[typeKey];
  if (!list) return fromLib;
  const taken = new Set(fromLib.map((b) => norm(b.title)));
  const need = count - fromLib.length;
  const pool = shuffle(list.filter((b) => !skip.has(norm(b.t)) && !taken.has(norm(b.t))));
  /* 넉넉히 조회해 두고 앞에서부터 채운다 — 카카오에 없는 책이 섞여 있어도
     세 칸이 비지 않는다. */
  const found = await Promise.all(pool.slice(0, need + 2).map(lookup));
  return [...fromLib, ...found.filter(Boolean)].slice(0, count);
}

/* toGenre 는 홈의 '도서관 대출 급상승 책' 담기에서도 쓴다 — 정보나루 분류를
   그대로 담으면 books.genre 가 오염되는 것은 거기서도 같다. */
export { PICKS, toGenre };
